import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaHardHat, FaClipboardCheck, FaShieldAlt, FaChartLine, 
  FaUserTie, FaHandshake, FaArrowRight, FaCheckCircle, FaBuilding 
} from 'react-icons/fa';


// --- IMPORTS ---
import styles from './LandingPage.module.css'; // Your existing styles
import devHeroImage from '../../assets/images/business_hero.jpg'; 
import dashboardImage from '../../assets/images/imgBusinessProcess.jpg';
import renoTradiesImage from "../../assets/images/img_trade_reno.jpg";

// --- SHARED COMPONENTS ---
import Header from './components/Header';
import Footer from './components/Footer';
import SocialProofEngine from '../../components/SocialProof/SocialProofEngine';
import AvailableJobs from '../../components/LiveJobs/AvailableJobs';
import SearchFormComponent from "../../pages/Dashboards/SearchFormComponent";
import AiSearchAssistant from "../../components/AiSearchAssistant/AiSearchAssistant";

import AppDownloadSection from './components/AppDownloadSection'; 
import TestimonialsSection from './components/TestimonialsSection'; 
import FinalCtaSection from './components/FinalCtaSection'; 

// --- SCROLL HELPER ---
const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) element.scrollIntoView({ behavior: 'smooth' });
};

// --- 1. HERO SECTION (Updated with Search Pill) ---
const DeveloperHero = () => {
  return (
    <section 
      className="bs-hero-section" 
      style={{ 
        backgroundImage: `linear-gradient(rgba(5, 21, 52, 0.9), rgba(5, 21, 52, 0.8)), url(${devHeroImage})`,
      }}
    >
      <div className="bs-container">
        <div className="bs-hero-content" style={{textAlign: 'center', margin: '0 auto'}}>
          
          <div className="bs-rating-badge" style={{justifyContent: 'center'}}>
            <span className="bs-stars">★★★★★</span>
            <span>TRUSTED BY 500+ DEVELOPERS</span>
          </div>
          
          <h1 className="bs-hero-title">
            SCALE YOUR PROJECTS WITH AN <br/> 
            <span className="bs-text-gold-gradient">ON-DEMAND WORKFORCE</span>
          </h1>
          
          <p className="bs-hero-subtitle" style={{margin: '0 auto 40px auto'}}>
            Stop the endless search for reliable subcontractors. 
            Search our exclusive network of vetted trades ready to quote.
          </p>

          {/* --- REPLACED WITH SEARCH FORM COMPONENT --- */}
          {/* This works because Developers "Search" for trades, they don't "List" themselves as trades */}
          <div className={styles.heroSearchWrapper}>
             <SearchFormComponent className={styles.landingPageSearchForm} />
          </div>

          <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginTop: '20px'}}>
            Popular: Concreters, Surveyors, Electricians, Demolition
          </p>

        </div>
      </div>
    </section>
  );
};

// --- 2. PAIN POINTS (New Section) ---
const PainPoints = () => {
    return (
        <section style={{padding: '60px 0', background: '#fff'}}>
            <div className="bs-container" style={{textAlign: 'center'}}>
                <h2 style={{color: '#0a1f44', marginBottom: '40px', fontSize: '32px', fontWeight: '800'}}>
                    DELAYS COST YOU <span style={{color: '#d32f2f'}}>MONEY.</span>
                </h2>
                <div className="bs-container-grid" style={{gridTemplateColumns: '1fr 1fr 1fr', gap: '30px'}}>
                    <div style={{padding: '20px', background: '#fff0f0', borderRadius: '12px', border: '1px solid #ffcdd2'}}>
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>The Flake Factor</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Trades that don't show up kill your timeline and push back your handover date.</p>
                    </div>
                    <div style={{padding: '20px', background: '#fff0f0', borderRadius: '12px', border: '1px solid #ffcdd2'}}>
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>Compliance Risk</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Using uninsured "cowboys" exposes your entire development to massive liability.</p>
                    </div>
                    <div style={{padding: '20px', background: '#fff0f0', borderRadius: '12px', border: '1px solid #ffcdd2'}}>
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>Price Gouging</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Last-minute hiring often means paying a premium just to get the job done.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

// --- 3. B2B SUBCONTRACTING ---
const SubcontractingSection = () => {
  return (
    <section className="bs-connect-section" style={{paddingTop: '60px', paddingBottom: '60px'}}>
      <div className="bs-container">
        <div className="bs-connect-grid" style={{alignItems: 'center'}}>
          
          <div className="bs-connect-content-col">
            <h2 className="bs-connect-title">
              BUILD YOUR <br />
              <span className="bs-font-thin">B2B NETWORK</span>
            </h2>
            <p className="bs-connect-desc">
              You aren't just a homeowner; you are a business. BuildStart allows you to 
              <strong> create projects and subcontract work</strong> to other verified specialists. 
              Fill labour gaps instantly and keep your site moving.
            </p>
            <ul style={{listStyle: 'none', padding: 0, marginBottom: '30px', color: 'rgba(255,255,255,0.9)'}}>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Direct Product & Trade Search
                </li>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Manage Multiple Sites from One Dashboard
                </li>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Rate & Review Subcontractors
                </li>
            </ul>
            <Link to="/select-role" className="bs-btn-pill-primary">
              Find Subcontractors
            </Link>
          </div>

            <div className="bs-connect-image-col" style={{justifyContent: 'center'}}>
            <img 
              src={renoTradiesImage} 
              alt="Plenty of tradies" 
              style={{
                width: '100%',
                maxWidth: '450px',        /* Limits the size */
                borderRadius: '16px',     /* Rounded corners */
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)', /* Pop-out shadow */
                objectFit: 'cover',
                height: 'auto'
              }} 
            />
          </div>

        </div>
      </div>
    </section>
  );
};

// --- 4. RISK MITIGATION (Reusing your section, styled better) ---
const RiskMitigation = () => {
  return (
    <section style={{padding: '80px 0', background: '#f8f9fa'}}>
      <div className="bs-container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{color: '#0a1f44', fontSize: '36px', fontWeight: '800', textTransform: 'uppercase'}}>
             Eliminate Site Risk
          </h2>
          <p style={{color: '#666', fontSize: '18px', maxWidth: '700px', margin: '0 auto'}}>
            One uninsured contractor can shut down a site. 
            Our <strong>Vetting Gauntlet</strong> ensures compliance before they step on your property.
          </p>
        </div>

        <div className="bs-container-grid" style={{gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px'}}>
          {[
            { icon: FaShieldAlt, title: "License Check", desc: "Real-time government database verification." },
            { icon: FaClipboardCheck, title: "Insurance", desc: "Automated tracking for Public Liability." },
            { icon: FaUserTie, title: "Reputation", desc: "3-Star minimum rating requirement." },
            { icon: FaChartLine, title: "Monitoring", desc: "Continuous performance checks." }
          ].map((item, i) => (
            <div key={i} style={{background: 'white', padding: '30px 20px', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)'}}>
                <div style={{width: '60px', height: '60px', background: '#e0f2fe', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto'}}>
                    <item.icon size={28} color="#0066ff" />
                </div>
                <h3 style={{fontSize: '18px', fontWeight: '700', color: '#0a1f44', marginBottom: '10px'}}>{item.title}</h3>
                <p style={{fontSize: '14px', color: '#666', lineHeight: '1.5'}}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 5. AI PROJECT SECTION ---
const AiProjectSection = () => {
    // Reusing the style from your previous code, but ensuring class consistency
  return (
    <section style={{padding: '80px 0', background: '#fff'}}>
      <div className="bs-container-grid">
          
          <div style={{position: 'relative'}}>
             <img src={dashboardImage} alt="Dashboard" style={{width: '100%', borderRadius: '16px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)'}} />
             {/* Floating Badge */}
             <div style={{position: 'absolute', bottom: '30px', left: '-20px', background: 'white', padding: '15px 25px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '15px'}}>
                <div style={{background: '#dcfce7', padding: '10px', borderRadius: '8px'}}><FaCheckCircle color="#16a34a"/></div>
                <div>
                    <div style={{fontWeight: '700', color: '#333'}}>Scope Generated</div>
                    <div style={{fontSize: '12px', color: '#666'}}>AI saved 4 hours</div>
                </div>
             </div>
          </div>

          <div className="bs-content-col">
            <h2 style={{fontSize: '42px', fontWeight: '800', color: '#0a1f44', marginBottom: '20px', lineHeight: '1.1'}}>
              RUN RENOVATIONS ON <br/>
              <span style={{color: '#0066ff'}}>AUTOPILOT</span>
            </h2>
            <p style={{fontSize: '16px', color: '#555', marginBottom: '30px', lineHeight: '1.6'}}>
              Flipping a house? Use our <strong>AI Project Templates</strong> (e.g., "Cosmetic Kitchen Refresh") 
              to automatically generate tasks, stages, and timelines. 
              Drag and drop tasks and invite trades directly to specific stages.
            </p>
            <Link to="/select-role" className="bs-btn-primary" style={{backgroundColor: '#0a1f44'}}>
                Try AI Tools Free
            </Link>
          </div>
      </div>
    </section>
  );
};

// --- 6. SIMPLE PRICING (Don't overcomplicate for Devs yet) ---
const SimpleDeveloperPricing = () => {
    return (
        <section id="partnership-plans" style={{padding: '80px 0', background: '#0a1f44', color: 'white', textAlign: 'center'}}>
            <div className="bs-container">
                <h2 style={{fontSize: '36px', fontWeight: '800', marginBottom: '20px'}}>PLANS BUILT FOR SCALE</h2>
                <p style={{marginBottom: '50px', fontSize: '18px', opacity: 0.8}}>Join as a Developer or Renovator today.</p>
                
                <div className="bs-container-grid" style={{gap: '30px'}}>
                    {/* FREE TIER - The Hook */}
                    <div style={{background: 'white', color: '#333', padding: '40px', borderRadius: '16px', textAlign: 'left'}}>
                        <h3 style={{fontSize: '24px', fontWeight: '800', color: '#0a1f44'}}>Standard</h3>
                        <div style={{fontSize: '36px', fontWeight: '800', color: '#0066ff', margin: '10px 0 20px 0'}}>Free <span style={{fontSize:'16px', color:'#666', fontWeight:'500'}}>/ forever</span></div>
                        <ul style={{listStyle: 'none', padding: 0, marginBottom: '30px'}}>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> Post Unlimited Jobs</li>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> Search Verified Trades</li>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> Access Basic AI Templates</li>
                        </ul>
                        <Link to="/register/developer" className="bs-btn-pricing-outline" style={{textAlign:'center'}}>Create Free Account</Link>
                    </div>

                    {/* PRO TIER - The Upsell */}
                    <div style={{background: 'linear-gradient(135deg, #fff 0%, #f0f9ff 100%)', color: '#333', padding: '40px', borderRadius: '16px', textAlign: 'left', border: '2px solid #0066ff', position: 'relative'}}>
                        <div style={{position: 'absolute', top: '-15px', right: '20px', background: '#0066ff', color: 'white', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '700'}}>RECOMMENDED</div>
                        <h3 style={{fontSize: '24px', fontWeight: '800', color: '#0a1f44'}}>Enterprise</h3>
                        <div style={{fontSize: '24px', fontWeight: '800', color: '#0a1f44', margin: '10px 0 20px 0'}}>Contact us <span style={{fontSize:'16px', color:'#666', fontWeight:'500'}}>/ mo</span></div>
                        <ul style={{listStyle: 'none', padding: 0, marginBottom: '30px'}}>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> AI Assistant Project Management Tools</li>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> AI Assistent Search </li>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> AI Job Assistant</li>
                            <li style={{marginBottom: '12px', display:'flex', gap:'10px'}}><FaCheckCircle color="#0066ff"/> Dedicated Support</li>
                        </ul>
                        <Link to="/contact-sales" className="bs-btn-pricing-primary" style={{textAlign:'center'}}>Contact Sales</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

// --- 7. FINAL CTA ---
/*
const FinalCtaSection = () => (
    <section className="bs-final-cta-section">
        <div className="bs-container">
            <div className="bs-final-cta-content">
                <h2 className="bs-cta-title">
                    READY TO BUILD YOUR <span className="bs-text-gold-gradient">EMPIRE?</span>
                </h2>
                <p className="bs-cta-subtitle">
                    Join thousands of professionals building faster, cheaper, and safer on BuildStart.
                </p>
                <div className="bs-cta-btn-wrapper">
                    <Link to="/select-role" className="bs-btn-cta-pill">
                        Create Your Free Profile <FaArrowRight />
                    </Link>
                </div>
            </div>
        </div>
    </section>
);

*/


// --- MAIN PAGE COMPONENT ---
const DevelopersGrowthPageNew = () => {
  return (
    <div className="developer-landing-page">
      <Header />
      
      {/* 1. Hero with Search Pill */}
      <DeveloperHero />
      
      {/* 2. Social Proof */}
      <SocialProofEngine />

      {/* 3. Pain Points (Why use us?) */}
      <PainPoints />

      {/* 4. Subcontracting Feature */}
      <SubcontractingSection />

      {/* 6. Vetting / Trust */}
      <RiskMitigation />

      {/* 7. Live Job Activity */}
      <section style={{padding: '80px 0', background: '#f7f9fa'}}>
         <AvailableJobs limit={3} />
      </section>

      {/* 5. AI Features */}
      <AiProjectSection />





      {/* 8. Simplified Plans */}
      <SimpleDeveloperPricing />


      <AppDownloadSection />

      <TestimonialsSection />


      <FinalCtaSection 
        title="READY TO BUILD YOUR " 
        highlighttext="EMPIRE?" 
        subtitle="Join thousands of professionals building faster, cheaper, and safer on BuildStart." 
      />


      <Footer />

      <AiSearchAssistant />
    </div>
  );
};

export default DevelopersGrowthPageNew;